module.exports = __webpack_public_path__ + "static/img/weixin_pay2.90ad5b26.jpg";